export enum ROVO_EXTENSION_PLATFORM_ANALYTICS {
  CHANNEL = "rovo-extension",
  PRODUCT = "rovoExtension",
}

export enum ANALYTICS_SCREEN_NAMES {
  EXTENSION_HOME_SCREEN = "extensionHomePage",
  EXTENSION_OPTIONS_SCREEN = "extensionOptionsPage",
  EXTENSION_NTP_LOGIN_SCREEN = "extensionNtpLogInPage",
  EXTENSION_CHAT_LOGIN_SCREEN = "extensionChatLogInPage",
  EXTENSION_NEW_WELCOME_SCREEN = "extensionNewWelcomePage",
  EXTENSION_AUTO_LOGIN_SCREEN = "extensionAutoLoginScreen",
  EXTENSION_REDIRECT_TO_IDENTITY_SCREEN = "extensionRedirectToIdentityScreen",
  EXTENSION_AFTER_LOGIN_REDIRECT = "extensionAfterLoginRedirectScreen",
  EXTENSION_AFTER_LOGOUT_REDIRECT = "extensionAfterLogoutRedirectScreen",
  EXTENSION_CHAT_SCREEN = "extensionChatPage",
  EXTENSION_POPUP_SCREEN = "extensionPopupPage",
  EXTENSION_UNINSTALL_SCREEN = "extensionUninstallPage",
  EXTENSION_ADMIN_OPTIONS_SCREEN = "extensionAdminOptionsScreen",
  EXTENSION_WHATS_NEW_SCREEN = "extensionWhatsNewPage",
  EXTENSION_CALENDAR_USER_AUTH_VIEW = "extensionCalendarUserAuthView",
  EXTENSION_NO_ROVO_VIEW = "extensionNoRovoView",
  EXTENSION_NO_SITE_VIEW = "extensionNoSiteView",
  EXTENSION_ANNOUNCEMENT_VIEW = "extensionAnnouncementView",
  EXTENSION_NOTIFICATIONS_DRAWER = "extensionNotificationsDrawer",
}

export enum ANALYTICS_UI_SUBJECTS {
  EXTENSION_CHAT_SEARCH_BAR = "extensionChatSearchBar",
  EXTENSION_QUICK_FIND_SEARCH_BAR = "extensionQuickFindSearchBar",
  EXTENSION_SEARCH_BAR_HOTKEY = "extensionSearchBarHotkey",
  HOME_PAGE_CHAT_BUTTON = "homePageChatButton",
  EXTENSION_LOGIN = "extensionLogIn",
  SHORTCUTS_ITEM = "shortcutsItem",
  SHORTCUTS_ADD_BUTTON = "shortcutsAddButton",
  SHORTCUTS = "shortcuts",
  NAV_BAR_CHAT_BUTTON = "navBarChatButton",
  NAV_BAR_LOGO = "navBarLogo",
  SITE_SELECTOR = "siteSelector",
  FEEDBACK_BUTTON = "feedbackButton",
  FEEDBACK_COLLECTOR = "feedbackCollector",
  CHROME_APP_SHORTCUT = "chromeAppShortcut",
  BOOKMARK = "bookmark",
  DROPDOWN_BOOKMARK = "dropdownBookmark",
  BOOKMARK_MANAGER_BUTTON = "bookmarkManagerButton",
  BOOKMARKS_BAR_CLOSE_BUTTON = "bookmarksBarCloseButton",
  APP_SWITCHER_BUTTON = "appSwitcherButton",
  SHORTCUTS_CONFIG_MENU = "shortcutsConfigMenu",
  SHORTCUTS_CONFIG_MENU_OPTION = "shortcutsConfigMenuOption",
  SHORTCUTS_CONFIG_MENU_SAVE_BUTTON = "shortcutsConfigMenuSaveButton",
  SHORTCUTS_EDIT_OPTIONS_MENU = "shortcutsEditOptionsMenu",
  SHORTCUTS_EDIT_LINK_BUTTON = "shortcutsEditLinkButton",
  SHORTCUT_ITEM_EDIT_MODAL = "shortcutItemEditModal",
  PLUGIN_FEEDBACK_YES_BUTTON = "pluginFeedbackYesButton",
  PLUGIN_FEEDBACK_NO_BUTTON = "pluginFeedbackNoButton",
  PLUGIN_FEEDBACK_REVIEW_CONFIRM_BUTTON = "pluginFeedbackReviewConfirmButton",
  PLUGIN_FEEDBACK_REVIEW_DISMISS_BUTTON = "pluginFeedbackReviewDismissButton",
  LOGIN_BUTTON = "loginButton",
  ANNOUNCEMENT_BANNER = "announcementBanner",
  ROVO_CHAT_TAB = "rovoChatTab",
  ROVO_SEARCH_TAB = "rovoSearchTab",
  ROVO_GOOGLE_TAB = "rovoGoogleTab",
  DEFAULT_SEARCH_TAB_OPTION = "defaultSearchTabUserOption",
  RECENT_WORK_ROW = "recentWorkRow",
  RECENT_WORK_DISMISS_BUTTON = "recentWorkDismissButton",
  GLOBAL_CREATE_BUTTON = "globalCreateButton",
  GLOBAL_CREATE_ITEM = "globalCreateItem",
  OPEN_MENU_TAB_BUTTON = "openMenuTabButton",
  CALENDAR_DISMISS_BUTTON = "calendarDismissButton",
  CALENDAR_JOIN_MEETING_BUTTON = "calendarJoinMeetingButton",
  CALENDAR_VIEW_MEETING_BUTTON = "calendarViewMeetingButton",
  CALENDAR_DATE_PICKER = "calendarDatePicker",
  CALENDAR_DATE_CHEVRON_BUTTON = "calendarDateChevronButton",
  CALENDAR_SHOW_MORE_BUTTON = "calendarShowMoreButton",
  CALENDAR_CONNECT_BUTTON = "calendarConnectButton",
  CALENDAR_ADMIN_CONNECT_BUTTON = "calendarAdminConnectButton",
  CALENDAR_EVENT_CARD = "calendarEventCard",
  UNINSTALL_SURVEY = "uninstallSurvey",
  NTP_CALENDAR_OPTION = "ntpCalendarOption",
  ADMIN_OPTIONS_UPLOAD_BACKGROUND_BUTTON = "adminOptionsUploadBackgroundButton",
  ADMIN_OPTIONS_REMOVE_BACKGROUND_BUTTON = "adminOptionsRemoveBackgroundButton",
  ADMIN_OPTIONS_BACKGROUND_FILE_SELECTOR = "adminOptionsBackgroundFileSelector",
  ADMIN_OPTIONS_UPLOAD_LOGO_BUTTON = "adminOptionsUploadLogoButton",
  ADMIN_OPTIONS_REMOVE_LOGO_BUTTON = "adminOptionsRemoveLogoButton",
  ADMIN_OPTIONS_LOGO_FILE_SELECTOR = "adminOptionsLogoFileSelector",
  ADMIN_OPTIONS_CUSTOMIZE_LOGO_BEHAVIOR_BUTTON = "adminOptionsCustomizeLogoBehaviorButton",
  ADMIN_OPTIONS_SITE_SELECTOR = "adminOptionsSiteSelector",
  VIEW_PROFILE_BUTTON = "viewProfileButton",
  WELCOME_PAGE_FEATURE_BUTTON = "welcomePageFeatureButton",
  NEW_WELCOME_PAGE_GET_STARTED = "newWelcomePageGetStarted",
  ADD_NEW_ANNOUNCEMENT_BUTTON = "addNewAnnouncementButton",
  DELETE_ANNOUNCEMENT_BUTTON = "deleteAnnouncementButton",
  SAVE_ANNOUNCEMENT_BUTTON = "saveAnnouncementButton",
  MANAGE_ANNOUNCEMENTS = "manageAnnouncements",
  HIDE_ANNOUNCEMENTS_BUTTON = "hideAnnouncementButton",
  ANNOUNCEMENT_VIEW_WINDOW = "announcementViewWindow",
  ANNOUNCEMENT_TOGGLE_BUTTON = "announcementToggleButton",
  CONNECTOR_ICON_BUTTON = "connectorIconButton",
  CONNECTOR_DROPDOWN = "connectorDropdown",
  CONNECTOR_DROPDOWN_CONNECT = "connectorDropdownConnect",
  SETTING_TOGGLE = "settingToggle",
  SETTING_PIN_EXTENSION_BUTTON = "settingPinExtensionButton",
  SETTINGS_NAVIGATION_SECTION = "settingsNavigationSection",
  NTP_AGENT_MENU = "ntpAgentMenu",
  NTP_AGENT_MENU_OPTION = "ntpAgentMenuOption",
  NTP_BROWSE_AGENTS_MODAL = "ntpBrowseAgentsModal",
  NOTIFICATIONS_BUTTON = "notificationsButton",
}

export enum ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS {
  LOGIN = "login",
  LOGOUT = "logout",
  ADMIN_OPTIONS_BACKGROUND_UPLOAD = "adminOptionsBackgroundUpload",
  ADMIN_OPTIONS_BACKGROUND_REPLACE = "adminOptionsBackgroundReplace",
  ADMIN_OPTIONS_BACKGROUND_DELETE = "adminOptionsBackgroundDelete",
  ADMIN_OPTIONS_LOGO_DELETE = "adminOptionsLogoDelete",
  ADMIN_OPTIONS_LOGO_UPLOAD = "adminOptionsLogoUpload",
  ADMIN_OPTIONS_LOGO_REPLACE = "adminOptionsLogoReplace",
  ADMIN_OPTIONS_LOGO_BEHAVIOR = "adminOptionsLogoBehavior",
  CALENDAR_MEETING_JOIN = "calendarMeetingJoin",
  CALENDAR_MEETING_VIEW = "calendarMeetingView",
  CALENDAR_PICKER_NAVIGATE = "calendarPickerNavigate",
  CALENDAR_OAUTH = "calendarOAuth",
  RECENT_WORK_ROW = "recentWorkRow",
  SHORTCUTS_ITEM = "shortcutsItem",
  BOOKMARK = "bookmark",
  BOOKMARKS_BAR = "bookmarksBar",
  BOOKMARK_MANAGER = "bookmarkManager",
  CHROME_APPS = "chromeApps",
  WHATS_NEW = "whatsNew",
  CHAT_SIDEPANEL = "chatSidepanel",
  OPEN_OPTIONS = "openOptions",
  TOP_BAR = "topBar",
  PROFILE_CARD = "profileCard",
  PROFILE_PAGE = "profilePage",
  THEME = "theme",
  ROVO_EXTENSION_FRONTEND = "rovoExtensionFrontend",
  UPDATE_ANNOUNCEMENT = "updateAnnouncement",
  UPDATE_ANNOUNCEMENT_FAILED = "updateAnnouncementFailed",
  ANNOUNCEMENT_LOADED = "announcementLoaded",
  CUSTOM_FONT_COLOR = "customFontColor",
  CUSTOM_NAVBAR_COLOR = "customNavbarColor",
  WELCOME_POPOVER = "welcomePopover",
}

export enum ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS {
  FG_CLIENT_INITIALIZATION = "featureGatesClientInitialization",
}
